import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "fitlink_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
  };
  const decline = () => {
    localStorage.setItem(KEY, "declined");
    setVisible(false);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    }
  };

  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] rounded-xl bg-neutral-950 text-white shadow-2xl border border-neutral-800 p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="font-bold mb-1">We use essential cookies</div>
          <p className="text-sm text-neutral-300 leading-relaxed">
            FitLink Ireland uses cookies to keep you logged in and remember preferences.
            No advertising or tracking cookies. See our <Link to="/legal/cookies" className="text-emerald-400 underline">Cookie Policy</Link>.
          </p>
        </div>
        <button aria-label="Close" onClick={decline} className="text-neutral-400 hover:text-white">
          <X size={16}/>
        </button>
      </div>
      <div className="mt-4 flex gap-2">
        <button data-testid="cookie-accept" onClick={accept} className="btn-accent flex-1 justify-center">Accept</button>
        <button data-testid="cookie-decline" onClick={decline} className="btn-secondary flex-1 justify-center !bg-transparent !border-neutral-700 !text-white hover:!bg-neutral-900">Decline</button>
      </div>
    </div>
  );
}
